import { render, staticRenderFns } from "./dealDetail.vue?vue&type=template&id=3a557d26&scoped=true&"
import script from "./dealDetail.vue?vue&type=script&lang=js&"
export * from "./dealDetail.vue?vue&type=script&lang=js&"
import style0 from "./dealDetail.vue?vue&type=style&index=0&id=3a557d26&lang=scss&scoped=true&"
import style1 from "./dealDetail.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a557d26",
  null
  
)

export default component.exports